import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AvisoPlataformaComponent } from './aviso-plataforma.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AvisoPlataformaComponent],
  exports: [AvisoPlataformaComponent],
})
export class AvisoPlataformaModule {}
